import Image from "next/image";
import { PortableText } from "@portabletext/react";
import RichText from "./RichText";

export default function PersonnelSection({ people }) {
  if (!people?.length) return null;

  return (
    <section className="personnel mt-8 pt-8 border-t-2" id="henkilokunta">
      <h2 className="section-heading">Henkilökunta</h2>
      <ul className="grid gap-12 md:grid-cols-2 lg:grid-cols-3">
        {people.map((person) => (
          <li key={person._id} className="flex flex-col gap-4">
            {person.image?.asset?.url && (
              <div className="personnel-image">
                <Image
                  src={person.image.asset.url}
                  alt={person.name}
                  width={500}
                  height={400}
                  style={{ objectFit: "cover" }}
                />
              </div>
            )}
            <div className="personnel-content">
              <h3 className="subsection-heading">{person.name}</h3>
              <RichText className="text-block" value={person.description} />
            </div>
          </li>
        ))}
      </ul>

      <style jsx>{`
        @media (min-width: 768px) {
          .personnel-list {
            grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
          }
        }

        .personnel-item {
          display: flex;
          flex-direction: column;
          gap: 1rem;
        }

        .personnel-image {
          aspect-ratio: 3 / 2;
          overflow: hidden;
        }

        .personnel-content h3 {
          margin: 0.5rem 0;
        }
      `}</style>
    </section>
  );
}
